import { AssetType } from "@phc/common/gen/preferencesGen"
import { z } from "zod"

export const assetCSVSchema = z.object({
  Name: z.string().describe("Name"),
  Type: z
    .string()
    .optional()
    .transform(t => {
      const type = AssetType[t as keyof typeof AssetType]
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- enum key lookup can be undefined at runtime
      return type ?? AssetType.ASSET_TYPE_UNSPECIFIED
    })
    .describe("Type"),
  Latitude: z.string().optional().describe("Latitude"),
  Longitude: z.string().optional().describe("Longitude"),
  Address: z.string().optional().describe("Address"),
  "Threat Radius": z
    .string()
    .optional()
    .transform(s => (s ? parseInt(s) : undefined))
    .describe("Threat Radius"),
  Groups: z
    .string()
    .transform(g => g.split(",").map(s => s.trim()))
    .describe("Groups"),
  Error: z.string().optional(),
})

// This validates that address or lat/lng are provided.
// Refinements prevent shape data from being exported from zod schemas,
// so this has to happen separately from the schema model creation if we want
// to validate the presence of separate columns and access schema shapes elsewhere.
export const locationValidatedAssetSchema = assetCSVSchema
  .refine(data => !!(data.Latitude && data.Longitude) || !!data.Address, {
    message: "Either Address or both Latitude and Longitude must be provided",
    path: ["Address"],
  })
  .refine(
    data => {
      const radius = data["Threat Radius"]?.toString()
      return !radius || !isNaN(parseInt(radius))
    },
    {
      message: "Threat radius must be a number",
      path: ["Threat Radius"],
    }
  )

export type AssetCSVRow = z.infer<typeof locationValidatedAssetSchema>

export const assetSchemaArray = z.array(locationValidatedAssetSchema)
